import React, { FunctionComponent } from 'react';
import Overlay from '../../Overlay';

/* Interfaces */
interface LightboxProps {
  children: any;
  close: () => void;
}

/* Helpers */
const maxZIndexAllowedByHtml = 2147483647;

/* Component */
const Lightbox: FunctionComponent<LightboxProps> = ({ close, children }: LightboxProps) => (
  <Overlay backgroundColor="rgba(0, 0, 0, 0.6)" close={close} closeOnClick zIndex={maxZIndexAllowedByHtml}>
    {children}
  </Overlay>
);

export default Lightbox;
